/**
 * All possible ACS transactions
*/
export enum ACSTransactionType {
    None = 0
    , AllowUnbalancedReceipt = 1
    , AllowLongMessage = 2
    , UpdCustDetail = 3
    , UpdCustName = 4
    , UpdCustAddress = 5
    , UpdCustIdentification = 6
    , UpdCustCertification = 7
    , UpdCustContact = 8
    , UpdCustCharacteristic = 9
    , UpdCustPhysicalAttributes = 10
    , UpdCustMedical = 11
    , UpdCustAffiliations = 12
    , SetAddressUndeliverable = 13
}
